import { Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { memo } from 'react'

type RecordingStartCountdownProps = {
  secondsRemaining: number
}

// eslint-disable-next-line react/display-name
export const RecordingCountdown = memo(({ countdownSeconds }: { countdownSeconds: number }) => {
  return (
    <div className="flex flex-col items-center gap-2">
      <div
        className="bg-green relative flex items-center justify-center rounded-full"
        style={{ width: 96, height: 96 }}
      >
        <span className="text-5xl font-bold text-white tabular-nums">{countdownSeconds}</span>
      </div>
      <Text type="body2-regular" className="text-gray-90">
        <Trans>Recording starts in...</Trans>
      </Text>
    </div>
  )
})

export function RecordingStartCountdown({ secondsRemaining }: RecordingStartCountdownProps) {
  return (
    <>
      <RecordingCountdown countdownSeconds={secondsRemaining} />
      <Text type="body3-regular" className="text-gray-80 text-center">
        <Trans>Get ready to start your conversation!</Trans>
      </Text>
    </>
  )
}
